import { Routes } from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  LocalisationDataComponentConfig,
  LocalisationDataSectionComponent
} from '../common/localisation-data-section/localisation-data-section.component';

export const stages: string[] = [
  'Wnioskodawca',
  'Dane wniosku',
  'Lokalizacja',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  successUrl: '../lokalizacja',
  cancelUrl: '../wnioskodawca',
  addIssuedDocumentTypeControl: true,
  addDocumentIssuePurposeControl: true
};

export const localisationDataComponentConfig: LocalisationDataComponentConfig = {
  stages,
  successUrl: '../zgody',
  cancelUrl: '../dane-wniosku'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../lokalizacja',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const wExtractAndDraftFromStudyRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: LocalisationDataSectionComponent,
    path: ':appId/lokalizacja',
    data: localisationDataComponentConfig
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
